import { NoddiIcon } from 'noddi-ui-common';
import { DropdownMenuItem, NoddiDialog } from 'noddi-ui-web';
import { useState } from 'react';
import type { UserSessionData } from '../../contexts/AuthContext';
import { useCanImpersonate } from './canImpersonate';
import { ImpersonateUserDialog } from './ImpersonateUserDialog';

export const ImpersonateMenuItem = ({ onImpersonated }: { onImpersonated?: (userData: UserSessionData) => void }) => {
  const canImpersonate = useCanImpersonate();
  const [open, setOpen] = useState(false);

  if (!canImpersonate) {
    return null;
  }

  return (
    <>
      <DropdownMenuItem
        onSelect={(e) => {
          e.preventDefault();
          setOpen(true);
        }}
      >
        <NoddiIcon name='Users' />
        <span>Impersonate user</span>
      </DropdownMenuItem>
      <NoddiDialog
        open={open}
        onClose={() => setOpen(false)}
        title='Impersonate user'
        description='Select a user from the list to view the application as them and take actions on their behalf'
        maxWidth='lg'
        // Fixed height so fillHeight + infinite scroll get a stable flex chain inside the dialog.
        className='h-[85vh] max-h-[85vh]'
        contentClassName='flex min-h-0 flex-1 flex-col overflow-hidden'
      >
        <ImpersonateUserDialog onClose={() => setOpen(false)} onImpersonated={onImpersonated} />
      </NoddiDialog>
    </>
  );
};
